module.exports = __webpack_public_path__ + "static/media/spinman-point.09a25b10.png";